import CurrencyFormatter from 'currency-formatter'
import { get, reduce, cloneDeep, merge, pickBy, keys, omit, pick, mapValues } from 'lodash';
import * as MarkdownIt from 'markdown-it'
import QueryString from 'query-string'


const environment = process.env.REACT_APP_ENVIRONMENT

export const relevant = (obj:{ stage:string, test:string, production:string }) => get(obj, environment)


export function optionsToInts(options){
    return options.map(option => ({ label:option.label, value:parseInt(option.value) }))
}


export function toOptions(value){
    return keys(value).map((key) => ({
        label: key,
        value: value[key]
    })) 
}


export function toCurrency(value){
    if(value == null || value == "") return null;
    return CurrencyFormatter.format(value, {
        thousand: ",",
        precision: 0
    })
}


export function toDate(str:string){
    str = stripNonDateCharacters(str)

    var sanitised = ""
    for(var i = 0; i < str.length; i++){
        if(i == 2 || i == 5){
            if(str[i] == "/") sanitised += "/"
            else sanitised += "/" + str[i]
        }else{
            if(str[i] != "/") sanitised += str[i]
        }
       
    }

    sanitised = sanitised.slice(0, 10)
    return sanitised
}

//typescript will not throw exception if you pass values with any or unknown type declaration so need to test and convert to string
export function asNumber(val: string | number | null | undefined) {
    if (val === "" || val == null) return null;
    
    // Convert to string if it's a number, then strip non-numeric characters
    const str = typeof val === "number" ? val.toString() : val;
    return parseInt(stripNonNumberCharacters(str));
}

export function stripNonNumberCharacters(str:string){
    return str.replace(/\D/g, '')
}


export function stripNonDateCharacters(str:string){
    return str.replace( /([^0-9/\//])/g, '' )
}


export function toCurrencyDecimal(value){
    if(value == null || value == "") return null;
    return CurrencyFormatter.format(value, {
        thousand: ",",
        precision: 2
    })
}


export function renderMarkdown(string){
    var md = new MarkdownIt({
        html: true,
        linkify: true,
    });

    return md.render(string)
}


export function condition(...args){
    for(var i = 0; i < args.length; i+=2){
        if(args[i] == true) return args[i+1]
    }
    return null;
}


export function getQueryString(){
    return QueryString.parse(QueryString.extract(window.location.href.replace("/#/", "")));
}


export function isStage(){
    return window.location.href.indexOf("stage")  > -1 ||
        window.location.href.indexOf("staging") > -1 ||
        window.location.href.indexOf("127.") > -1 ||
        window.location.href.indexOf("localhost") > -1;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/util.ts